export interface VizionEmbedUrlState {
  loading: boolean
  error: string | null
  embedurl: string | null
}

export enum ActionTypes {
  REQUEST_VIZION_EMBED_URL = 'REQUEST_VIZION_EMBED_URL',
  SUCCESS_VIZION_EMBED_URL = 'SUCCESS_VIZION_EMBED_URL',
  ERROR_VIZION_EMBED_URL = 'ERROR_VIZION_EMBED_URL',
}
